export default __webpack_public_path__ + "static/char-61-anr-50ab94213471c5a166b92679a5248adb.gif";